module.exports = __webpack_public_path__ + "img/Wagon_Back_Side_Right.4208e3ec.svg";